module.exports = __webpack_public_path__ + "img/DP001C_002.68358bba.png";